<div class="patrol-setup-page">
  <div class="page-header">
    <h1 class="page-title">{{ 'app.patrol.setup.title' | translate }}</h1>
    <p class="page-subtitle">{{ 'app.patrol.setup.subtitle' | translate }}</p>
  </div>

  <section class="communities-section">
    <div class="source-grid">
      @for (source of visibleSources(); track source.id) {
        <app-patrol-community-source-card
          [source]="source"
          [active]="enabledSources().has(source.id)"
          (toggled)="onSourceToggled(source.id, $event)"
        />
      }
    </div>
  </section>
</div>
